/**
 * Helper functions for user role checks
 */

/**
 * Check if the current user is an external user (agent or affiliate)
 * @returns {boolean}
 */
export const isExternalUser = () => {
  const roleName = Rails?.helpers?.currentUser?.role?.name;
  return roleName === 'agent' || roleName === 'affiliate';
};

/**
 * Check if the current user is admin or staff
 * @returns {boolean}
 */
export const isAdminOrStaff = () => {
  const { currentUser } = Rails?.helpers || {};
  if (!currentUser) return false;
  return currentUser.admin || currentUser.role?.name === 'staff' || currentUser.role?.name === 'admin';
};

/** @returns {boolean} true if the current team/user may send bulk SMS */
export const canSendBulkSms = () =>
  Boolean(Rails?.subscription?.can_sms) && !isExternalUser();
